import React from 'react'
const _isSettingMapServerType = window.SIMPL.mapServerType !== null && window.SIMPL.mapServerType !== undefined 
    && window.SIMPL.mapServerType !== "" && window.SIMPL.mapServerType !== ''& window.SIMPL.mapServerType !== '*';
const _mapServerType =  window.SIMPL.mapServerType;

export default function MyMapLayerSwitcher(props) {

    //ユーザー又はWEBで設定されている場合は、その設定を適用。
    //設定がされていない場合またはは、前回の状態を適用。　（※初回表示の場合は、デフォルト種類を適用）
    const mapServerType = _isSettingMapServerType ? _mapServerType : (props.mapOptions?.mapServerType === undefined ? props.defaultMapServerType : props.mapOptions?.mapServerType);

    // [ラベル]クリックメソッド
    function onCheck_Label(isChecked){
        props.map.setMapTypeId(isChecked ? "hybrid" : "satellite");
        props.updatemapOptions({ type:'isLabel', value:isChecked});
        props.updatemapOptions({type:'mapType',value:isChecked ? "hybrid" : "satellite"});
        props.updatemapOptions({type:'mapTypeId',value:isChecked ? "hybrid" : "GoogleMap_satellite"});
    }

    // [地形]クリックメソッド
    function onClick_Terrain(isChecked){
        props.map.setMapTypeId(isChecked ? "terrain" : "roadmap");
        props.updatemapOptions({ type:'isTerrain', value:isChecked});
        props.updatemapOptions({type:'mapType',value:isChecked ? "terrain" : "roadmap"});
        props.updatemapOptions({type:'mapTypeId',value:isChecked ? "terrain" : "GoogleMap_roadmap"});
    }

    function onClick_Option(item){
        //前に選択していたレイヤーの解除
        //未選択、又は、現在選択されているレイヤ―と同じレイヤーが選択されている（レイヤーOFF）場合は除外
        if(props.mapOptions.layerType !== null || props.mapOptions.layerType !== item.id){
            props.setShowLayerDetails({ type: props.mapOptions.layerType, value: false});
        }


        //詳細表示状態の格納
        props.setShowLayerDetails({ type: item.id, value: !props.showLayerDetails[item.id] });
        props.updatemapOptions({type:'layerType',value:!props.showLayerDetails[item.id] ?item.id :null});

        //詳細要素の格納
        props.setMapLayerDetailItems({type:item.id,value:{ id:item.id,title:item.title,authority:item.authority,usage:item.usage,usageURL:item.usageURL}})
    }

    function getContainerStyle() {
        //優先順：モバイルモード>検索結果一覧の有無>検索パネルの開閉
        var isMargin =  false;
        if(props.isMobileMode){
            isMargin = false;
        }else{
            if(props.isShowSearchResultPanel){
                if(props.searchPanelVisible){
                    isMargin = true;
                }else{
                    isMargin = false;
                }
            }else{
                isMargin = false;
            }
        }
        return {
            margin: "10px 10px 30px "+ (10 + (isMargin ? (props.width > 530 ? 400 : props.width) : 0)) +"px"
        };
    }

    return (
        <div className="MyMapLayerSwitcher" style={getContainerStyle()}>
            <header style={{height:"30px"}}>
                <button
                    className="closeButton"
                    label="閉じる"
                    onClick={props.onBack}
                    >
                    <div className="closeButton_icon">
                        <span>✕</span>
                    </div>
                </button>
            </header>

            {/* レイヤーJSONのlayerGroup */}
            {Object.keys(props.layerJson).length > 0 && props.layerJson.layerGroups.map(layerGroup=>
                (layerGroup.layers.length > 0 &&
                 layerGroup.layers.map(layer => !layer.authority || layer.authority.startsWith(window.SIMPL.userAuthority) || props.userAuthorities.some(item => layer.authority.startsWith(item))).includes(true) &&
                    <div className={"Switcher_1 Switcher_div"} key={layerGroup.name}>
                        <h2 className="Switcher_header">
                            {layerGroup.name}
                        </h2>
                        <ul className="Switcher_row">
                            {layerGroup.layers.map(layer => 
                            (!layer.authority || layer.authority.startsWith(window.SIMPL.userAuthority) || props.userAuthorities.some(item => layer.authority.startsWith(item))) &&
                                <li key={layer.id}
                                    className="Switcher_item"
                                    >
                                    <button
                                        className="showOption_Button"
                                        type="button"
                                        onClick={()=>{onClick_Option(layer)}}
                                        >
                                            <div><img src={"/Icons/Layers/"+ layer.icon} className={"showOption_icon " + (props.showLayerDetails[layer.id] ? "showOption_icon_active" : "")} alt="" /></div>
                                            <label
                                                className={"showOption_label " + (props.showLayerDetails[layer.id] ? "showOption_label_active" : "")}
                                                >{layer.title}
                                            </label>
                                    </button>
                                </li>
                            )
                            }
                        </ul>
                    </div>
                )
            )}

            <div className="Switcher_3 Switcher_div" key="mapServerType">
                <h2 className="Switcher_header" style={{width:"105%"}}>
                            地図の種類
                    {_isSettingMapServerType ?
                        <div></div>                    
                        :
                        <div className='MapServerTypeArea2' >
                            <select
                                onChange={(e)=>props.ChangeMapServerType(props.map,e.target.value)}
                                value={mapServerType}>
                                    {Object.keys(props.layerJson).length > 0 && props.layerJson.MapServers.map(MapServer=>
                                        <option key={MapServer.mapServerType} value={MapServer.mapServerType}>{MapServer.name}</option>
                                    )}
                            </select>
                        </div>
                    }
                </h2>

                {Object.keys(props.layerJson).length > 0 && props.layerJson.MapServers.map(MapServer=>
                    (MapServer.MapTypes.length > 0 &&
                        MapServer.mapServerType === mapServerType &&
                        <div className={"Switcher_1 Switcher_div"} key="mapTypeGroup">
                                {MapServer.MapTypes.map((MapTypeArr,idx) => 
                                (MapServer.mapServerType === mapServerType) &&
                                <ul className="Switcher_row" key={MapServer.mapServerType + "_" + idx}>
                                    {MapTypeArr.map(MapType => 
                                        <li key={MapType.id}
                                        className="Switcher_item"
                                        >
                                        <button
                                            className="showOption_Button"
                                            type="button"
                                            onClick={()=>{props.onMapTypeCheck(props.map,MapType.id,MapType.Style,(MapType?.originalDataURL?.length > 0 ? MapType?.originalDataURL[0] : undefined))}}
                                            >
                                                <div><img src={"/Icons/Layers/"+ MapType.icon} className={"showOption_icon " + (props.mapOptions.mapTypeId === MapType.id  ? "showOption_icon_active" : "")} alt="" /></div>
                                                <label
                                                    className={"showOption_label " + (props.mapOptions.mapTypeId === MapType.id ? "showOption_label_active" : "")}
                                                    >{MapType.title}
                                                </label>
                                        </button>
                                    </li>
                                    )}
                                 </ul>
                                )
                                }
                        </div>
                    )
                )}
            </div>
            
            {mapServerType === "GoogleMap"&&
                <div　className="Switcher_4">
                    <ul className="Switcher_row">
                        <li className="Switcher_item" key="option_terrain">
                            <label
                                htmlFor="option_terrain"
                                className="Switcher_item_label"
                                >
                                <input
                                type="checkbox"
                                id="option_terrain"
                                className="Switcher_item_checkbox"
                                style={{margin:"0 5px 0 0"}}
                                onChange={() => onClick_Terrain(!props.mapOptions.isTerrain)}
                                checked={props.mapOptions.isTerrain}
                                disabled={props.mapOptions.isTerrain_disabled}
                                />
                                地形
                            </label>
                        </li>
                        <li className="Switcher_item" key="option_label">
                            <label
                                htmlFor="option_label"
                                className="Switcher_item_label"
                                >
                                <input
                                type="checkbox"
                                id="option_label"
                                className="Switcher_item_checkbox"
                                style={{margin:"0 5px 0 0"}}
                                onChange={() => onCheck_Label(!props.mapOptions.isLabel)}
                                checked={props.mapOptions.isLabel}
                                disabled={props.mapOptions.isLabel_disabled}
                                />
                                ラベル
                            </label>
                        </li>
                    </ul>
                </div>
            }
        </div>
    );
}
